import { useContext } from 'react';
import { ChargebeeContext } from 'lib/contexts/ChargebeeContext';

export default function useChargebee() {
  return useContext(ChargebeeContext);
}
